import LayoutConfigTypes from '@/core/config/LayoutConfigTypes';

const config: LayoutConfigTypes = {
  themeName: 'Default',
  themeVersion: '8.1.1',
  demo: 'demo7',
  main: {
    type: 'default',
    primaryColor: '#009EF7',
    logo: {
      dark: '/media/logos/default-dark.svg',
      light: '/media/logos/default.svg',
    },
  },
  illustrations: {
    set: 'sketchy-1',
  },
  chat: {
    density: 'compact',
  },
  loader: {
    logo: '/media/logos/default-dark.svg',
    display: true,
    type: 'default',
  },
  scrollTop: {
    display: true,
  },
  header: {
    display: true,
    menuIcon: 'font',
    width: 'fluid',
    fixed: {
      desktop: true,
      tabletAndMobile: true,
    },
  },
  toolbar: {
    display: true,
    width: 'fluid',
    fixed: {
      desktop: true,
      tabletAndMobile: true,
    },
  },
  aside: {
    display: true,
    secondaryDisplay: true,
    theme: 'light',
    fixed: true,
    menuIcon: 'font',
    minimized: false,
    minimize: true,
    hoverable: true,
  },
  content: {
    width: 'fluid',
  },
  footer: {
    width: 'fluid',
  },
};

export default config;
